import Select from "./select";
import { PipelineStore } from "stores";
import { observer } from "mobx-react-lite";
import { PipelineStage } from "models/settings";
import { stringComparator } from "../../core/utils";

interface Props {
  value: Array<number>;
  onChange: (ids: Array<number>) => any;
  placeholder?: string;
  error?: boolean | string;
  label?: string;
  allowNoStage?: boolean;
}

const PipelineStageMultiSelect = observer(
  ({ onChange, value, placeholder, error, label, allowNoStage }: Props) => {
    const pipelineStages = [...PipelineStore.sortedItems];

    if (allowNoStage) {
      pipelineStages.push(new PipelineStage({ name: "No Stage", priority: 1000, id: -1 }));
    }

    const options = pipelineStages.sort((a, b) => stringComparator(a.name, b.name)).map(pipelineStage => {
      return { label: pipelineStage.name, value: pipelineStage.name, pipelineStageId: pipelineStage.id };
    });

    const filteredPipelineStages = pipelineStages.filter(e => value.includes(e.id));

    let values = null;
    if (filteredPipelineStages && filteredPipelineStages.length > 0) {
      values = filteredPipelineStages.map(pipelineStage => {
        return {
          label: pipelineStage.name,
          value: pipelineStage.name,
          pipelineStageId: pipelineStage.id,
        };
      });
    }

    return (
      PipelineStore.hasItems && (
        <Select
          className="pipeline-stage-multi-select"
          placeholder={placeholder}
          isSearchable={true}
          isMulti={true}
          onChangeMulti={(options) => onChange(options && options.map(o => o.pipelineStageId))}
          autoDefault={!placeholder}
          isClearable={!!placeholder && !!value}
          value={values}
          options={options}
          formatOption={(option) => option.label}
          valueField="pipelineStageId"
          labelField="name"
          error={error}
          label={label}
        />
      )
    );
  },
);

export default PipelineStageMultiSelect;
